<template>
  <div>
    <div class="h-full">
      <div class="rounded bg-white grid grid-cols-12 " :style="`height:` +  mainHeight + `px; !important`">
        <div class=" mx-2 shadow-md relative" :class="isFilterOpen ? 'box col-span-10' : 'box col-span-12'">
          <div class="bg-white cust_card p-2 heading-3 text-text1 justify-between flex">
            <p>Orders & Refunds</p>
            <div class="flex">
              <button v-if="firstLoading" @click="openDrag()" style="letter-spacing: 1px;" class="px-2 mx-3 heading-6 flex items-center text-white bg-primary2 cursor-pointer rounded">
                <!-- <i class="fas fa-file-export h-5 w-5 text-white"></i> -->
                Reorder Column
              </button>
              <button @click="exportReport()" :class="firstLoading && listingArray.length > 0 ? 'text-white bg-primary2 cursor-pointer' : 'cursor-not-allowed bg-gray-300 tet-text2 filter opacity-60'" style="letter-spacing: 1px;" class="px-2 cust_card heading-6 mr-8 flex items-center">
                <!-- <i class="fas fa-file-export h-5 w-5 text-white"></i> -->
                Export to Excel
              </button>
            </div>
            <div class="top-0 absolute" :class="isFilterOpen ? '-right-4' : 'transition-all delay-75 -right-2'" >
              <button id="toggle" class="bg-gray-600 hover:bg-gray-700 transition delay-75 w-11 h-11 rounded-l-full " @click="openCloseFilter()">
                <span v-if="isFilterOpen"><i class="fas fa-caret-right h-6 w-6 text-white mt-1"></i></span>
                <p v-if="!isFilterOpen"><i class="fas fa-caret-left h-6 w-6 text-white mt-1"></i></p>
              </button>
            </div>
          </div>
          <div style="overflow-y: auto; white-space: nowrap;border-collapse: collapse; " class="table_containder relative mt-2" v-if="firstLoading">
            <div class="text-text2  min-w-min heaer_row border p-2 border-gray1 font-bold flex heading-6-1 py-1 items-center" style="position: sticky;top: 0;background: white;">
              <div class="xsmall_col flex items-center p-2" style="width:54px;!important">
                <span class="">Index</span>
              </div>
              <div class="dates_col  flex items-center" :style="`width:` +  titleObj[0].width + `; !important;text-align:` + titleObj[0].align + `; !important; !important;justify-content:` + titleObj[0].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('orderDate', 0, titleObj[0].sort, titleObj[0].value)">{{titleObj[0].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[0].value) && titleObj[0].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[0].value) && !titleObj[0].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="small_col  flex items-center" :style="`width:` +  titleObj[1].width + `; !important;text-align:` + titleObj[1].align + `; !important; !important;justify-content:` + titleObj[1].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('status', 1, titleObj[1].sort, titleObj[1].value)">{{titleObj[1].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[1].value) && titleObj[1].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[1].value) && !titleObj[1].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="small_col  flex items-center" :style="`width:` +  titleObj[2].width + `; !important;text-align:` + titleObj[2].align + `; !important; !important;justify-content:` + titleObj[2].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('orderId', 2, titleObj[2].sort, titleObj[2].value)">{{titleObj[2].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[2].value) && titleObj[2].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[2].value) && !titleObj[2].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="small_col  flex items-center" :style="`width:` +  titleObj[3].width + `; !important;text-align:` + titleObj[3].align + `; !important; !important;justify-content:` + titleObj[3].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('sku', 3, titleObj[3].sort, titleObj[3].value)">{{titleObj[3].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[3].value) && titleObj[3].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[3].value) && !titleObj[3].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="desc_col  flex items-center" :style="`width:` +  titleObj[4].width + `; !important;text-align:` + titleObj[4].align + `; !important; !important;justify-content:` + titleObj[4].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('description', 4, titleObj[4].sort, titleObj[4].value)">{{titleObj[4].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[4].value) && titleObj[4].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[4].value) && !titleObj[4].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="mid_col  flex items-center" :style="`width:` +  titleObj[5].width + `; !important;text-align:` + titleObj[5].align + `; !important; !important;justify-content:` + titleObj[5].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 5, titleObj[5].sort, titleObj[5].value)">{{titleObj[5].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[5].value) && titleObj[5].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[5].value) && !titleObj[5].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="dates_col  flex items-center " :style="`width:` +  titleObj[6].width + `; !important;text-align:` + titleObj[6].align + `; !important; !important;justify-content:` + titleObj[6].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 6, titleObj[6].sort, titleObj[6].value)">{{titleObj[6].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[6].value) && titleObj[6].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[6].value) && !titleObj[6].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="small_col  flex items-center " :style="`width:` +  titleObj[7].width + `; !important;text-align:` + titleObj[7].align + `; !important; !important;justify-content:` + titleObj[7].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 7, titleObj[7].sort, titleObj[7].value)">{{titleObj[7].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[7].value) && titleObj[7].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[7].value) && !titleObj[7].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="avgSell_col  flex items-center " :style="`width:` +  titleObj[8].width + `; !important;text-align:` + titleObj[8].align + `; !important; !important;justify-content:` + titleObj[8].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('city', 8, titleObj[8].sort, titleObj[8].value)">{{titleObj[8].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[8].value) && titleObj[8].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[8].value) && !titleObj[8].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="avgSell_col  flex items-center " :style="`width:` +  titleObj[9].width + `; !important;text-align:` + titleObj[9].align + `; !important; !important;justify-content:` + titleObj[9].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('state', 9, titleObj[9].sort, titleObj[9].value)">{{titleObj[9].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[9].value) && titleObj[9].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[9].value) && !titleObj[9].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="avgSell_col  flex items-center " :style="`width:` +  titleObj[10].width + `; !important;text-align:` + titleObj[10].align + `; !important; !important;justify-content:` + titleObj[10].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('postcode', 10, titleObj[10].sort, titleObj[10].value)">{{titleObj[10].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[10].value) && titleObj[10].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[10].value) && !titleObj[10].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="avgSell_col  flex items-center" :style="`width:` +  titleObj[11].width + `; !important;text-align:` + titleObj[11].align + `; !important; !important;justify-content:` + titleObj[11].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('paymentMethod', 11, titleObj[11].sort, titleObj[11].value)">{{titleObj[11].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[11].value) && titleObj[11].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[11].value) && !titleObj[11].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="avgSell2_col  flex items-center " :style="`width:` +  titleObj[12].width + `; !important;text-align:` + titleObj[12].align + `; !important; !important;justify-content:` + titleObj[12].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 12, titleObj[12].sort, titleObj[12].value)">{{titleObj[12].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[12].value) && titleObj[12].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[12].value) && !titleObj[12].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="avgSell_col  flex items-center " :style="`width:` +  titleObj[13].width + `; !important;text-align:` + titleObj[13].align + `; !important; !important;justify-content:` + titleObj[13].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('quantity', 13, titleObj[13].sort, titleObj[13].value)">{{titleObj[13].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[13].value) && titleObj[13].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[13].value) && !titleObj[13].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[14].width + `; !important;text-align:` + titleObj[14].align + `; !important; !important;justify-content:` + titleObj[14].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('productSale', 14, titleObj[14].sort, titleObj[14].value)">{{titleObj[14].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[14].value) && titleObj[14].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[14].value) && !titleObj[14].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[15].width + `; !important;text-align:` + titleObj[15].align + `; !important; !important;justify-content:` + titleObj[15].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('productSaleTax', 15, titleObj[15].sort, titleObj[15].value)">{{titleObj[15].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[15].value) && titleObj[15].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[15].value) && !titleObj[15].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[16].width + `; !important;text-align:` + titleObj[16].align + `; !important; !important;justify-content:` + titleObj[16].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('shippingAmount', 16, titleObj[16].sort, titleObj[16].value)">{{titleObj[16].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[16].value) && titleObj[16].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[16].value) && !titleObj[16].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[17].width + `; !important;text-align:` + titleObj[17].align + `; !important; !important;justify-content:` + titleObj[17].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('shippingAmountTax', 17, titleObj[17].sort, titleObj[17].value)">{{titleObj[17].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[17].value) && titleObj[17].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[17].value) && !titleObj[17].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[18].width + `; !important;text-align:` + titleObj[18].align + `; !important; !important;justify-content:` + titleObj[18].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 18, titleObj[18].sort, titleObj[18].value)">{{titleObj[18].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[18].value) && titleObj[18].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[18].value) && !titleObj[18].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[19].width + `; !important;text-align:` + titleObj[19].align + `; !important; !important;justify-content:` + titleObj[19].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 19, titleObj[19].sort, titleObj[19].value)">{{titleObj[19].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[19].value) && titleObj[19].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[19].value) && !titleObj[19].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[20].width + `; !important;text-align:` + titleObj[20].align + `; !important; !important;justify-content:` + titleObj[20].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 20, titleObj[20].sort, titleObj[20].value)">{{titleObj[20].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[20].value) && titleObj[20].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[20].value) && !titleObj[20].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[21].width + `; !important;text-align:` + titleObj[21].align + `; !important; !important;justify-content:` + titleObj[21].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 21, titleObj[21].sort, titleObj[21].value)">{{titleObj[21].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[21].value) && titleObj[21].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[21].value) && !titleObj[21].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[22].width + `; !important;text-align:` + titleObj[22].align + `; !important; !important;justify-content:` + titleObj[22].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 22, titleObj[22].sort, titleObj[22].value)">{{titleObj[22].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[22].value) && titleObj[22].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[22].value) && !titleObj[22].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[23].width + `; !important;text-align:` + titleObj[23].align + `; !important; !important;justify-content:` + titleObj[23].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 23, titleObj[23].sort, titleObj[23].value)">{{titleObj[23].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[23].value) && titleObj[23].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[23].value) && !titleObj[23].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[24].width + `; !important;text-align:` + titleObj[24].align + `; !important; !important;justify-content:` + titleObj[24].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 24, titleObj[24].sort, titleObj[24].value)">{{titleObj[24].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[24].value) && titleObj[24].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[24].value) && !titleObj[24].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[25].width + `; !important;text-align:` + titleObj[25].align + `; !important; !important;justify-content:` + titleObj[25].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 25, titleObj[25].sort, titleObj[25].value)">{{titleObj[25].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[25].value) && titleObj[25].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[25].value) && !titleObj[25].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[26].width + `; !important;text-align:` + titleObj[26].align + `; !important; !important;justify-content:` + titleObj[26].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('', 26, titleObj[26].sort, titleObj[26].value)">{{titleObj[26].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[26].value) && titleObj[26].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[26].value) && !titleObj[26].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
              <div class="vsmall_col  flex items-center " :style="`width:` +  titleObj[27].width + `; !important;text-align:` + titleObj[27].align + `; !important; !important;justify-content:` + titleObj[27].align + `;`">
                <span class="cursor-pointer overFlowParaA" @click="sortByColumn('totalProductAmount', 27, titleObj[27].sort, titleObj[27].value)">{{titleObj[27].title}}</span>
                <span v-if="(pagination.sortBy === titleObj[27].value) && titleObj[27].sort"><i class="fas fa-sort-amount-down h-4 w-4 pl-1 text-primary2"></i></span>
                <p v-if="(pagination.sortBy === titleObj[27].value) && !titleObj[27].sort"><i class="fas fa-sort-amount-up h-4 w-4 pl-1 text-primary2"></i></p>
              </div>
            </div>
            <div :style="`max-height:` +  cardHight + `px; !important`" class="">
              <div id="DivValue"></div>
            </div>
          </div>
          <div class="layout m-2" v-if="listingArray.length === 0 && firstLoading">
            <div class="flex p-3 text-sm text-primary2 bg-white border-blue-100 border-2 rounded-lg  items-center" role="alert">
              <svg aria-hidden="true" class="flex-shrink-0 inline w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
              <span class="sr-only">Info</span>
              <div>
                <p class=" font-medium heading-4">No record found.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="box col-span-2 overflow-y-auto mx-2 shadow-md transition-transform delay-300 ease-in-out transition-2" :style="!isFilterOpen ? 'display: none' : ''">
          <GlobalFilter :callFrom="'PerimeterTechnologies.com'" :callParent="'accounting'"  @closeFilter="closeFilter" :isFilterOpen="isFilterOpen"/>
        </div>
      </div>
    </div>
    <div v-if="deleteConfirm" class="popup_overlay">
    <div style="width: 90%;" class="custom_dialog">
      <div class="text-text1 px-4 py-3 flex justify-between items-center">
        <span class="heading-3">Change Column display order</span>
        <div class="flex justify-end">
          <button class="bg-secondary text-white shadow mr-2 rounded-full px-4 py-1.5" style="letter-spacing: 1px;" @click="deleteConfirm = false;resetColumn()">Reset</button>
          <button class="bg-primary2 text-white shadow mr-2 rounded-full px-4 py-1.5" @click="deleteConfirm = false;saveToLocal()"><i class="fas fa-times h-5 w-5 text-white pt-1"></i></button>
        </div>
      </div>
      <hr>
      <div class="p-2 overflow-auto" style="max-height: 970px;">
        <span class="heading-4 text-text1">● Drag chip left/right to change Column display order</span>
        <draggable class="flex mt-4" :list="titleObj" group="people" @start="drag = true" @end="dragArray('false')" id='list'>
          <div v-for="(data, index) in titleObj" :key="index" class="bg-white text-sm p-1 items-center">
              <div class="flex items-center">
                <button class="border border-gray2 rounded-lg py-2 px-3 cursor-move">{{data.title}}</button>
              </div>
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import axios from 'axios'
import {downloadFile} from '@/utils/common.js'
import moment from 'moment'
import API from '@/api/App.js'
import GlobalFilter from '@/View/Admin/Components/filterWithoutSelection.vue'
// import Pagination from '@/View/components/pagination.vue'
export default {
  components: {
    draggable,
    GlobalFilter,
  },
  data () {
    return {
      drag: false,
      deleteConfirm: false,
      isFilterOpen: true,
      listingArray: [],
      resetColumnList: [
        {title: 'Date/Time', icon: '', value: 'orderDate', sort: false, width: '140px', align: 'start'},
        {title: 'Type', icon: '', value: 'status', sort: true, width: '84px', align: 'start'},
        {title: 'Order ID', icon: '', value: 'orderId', sort: true, width: '84px', align: 'start'},
        {title: 'Sku', icon: '', value: 'sku', sort: true, width: '84px', align: 'start'},
        {title: 'Description', icon: '', value: 'description', sort: true, width: '240px', align: 'start'},
        {title: 'Marketplace', icon: '', value: 'marketplace', sort: true, width: '180px', align: 'start'},
        {title: 'Account Type', icon: '', value: 'accountType', sort: true, width: '120px', align: 'start'},
        {title: 'FulFillment', icon: '', value: 'fulFillment', sort: true, width: '84px', align: 'start'},
        {title: 'Order City', icon: '', value: 'city', sort: true, width: '133px', align: 'start'},
        {title: 'Order State', icon: '', value: 'state', sort: true, width: '125px', align: 'start'},
        {title: 'Order Postal', icon: '', value: 'postcode', sort: true, width: '125px', align: 'start'},
        {title: 'Payment Method', icon: '', value: 'paymentMethod', sort: true, width: '133px', align: 'start'},
        {title: 'Tax Collection Model', icon: '', value: 'taxCollectionModel', sort: true, width: '138px', align: 'start'},
        {title: 'Quantity', icon: '', value: 'quantity', sort: true, width: '70px', align: 'right'},
        {title: 'Product Sales', icon: '', value: 'productSale', sort: true, width: '94px', align: 'right'},
        {title: 'Product Sales Tax', icon: '', value: 'productSaleTax', sort: true, width: '94px', align: 'right'},
        {title: 'Shipping Credits', icon: '', value: 'shippingAmount', sort: true, width: '94px', align: 'right'},
        {title: 'Shipping Credits Tax', icon: '', value: 'shippingAmountTax', sort: true, width: '94px', align: 'right'},
        {title: 'Gift Wrap Credits', icon: '', value: 'giftWrapCredits', sort: true, width: '94px', align: 'right'},
        {title: 'Gift Wrap Credits Tax', icon: '', value: 'giftWrapCreditsTax', sort: true, width: '94px', align: 'right'},
        {title: 'Promotional Rebates', icon: '', value: 'promotionalRebates', sort: true, width: '94px', align: 'right'},
        {title: 'Promotional Rebates Tax', icon: '', value: 'promotionalRebatesTax', sort: true, width: '94px', align: 'right'},
        {title: 'Marketplace Withheld Tax', icon: '', value: 'marketplaceWithheldTax', sort: true, width: '94px', align: 'right'},
        {title: 'Selling Fees', icon: '', value: 'sellingFees', sort: true, width: '94px', align: 'right'},
        {title: 'FBA Fees', icon: '', value: 'fBAFees', sort: true, width: '94px', align: 'right'},
        {title: 'Other Transaction Fees', icon: '', value: 'otherTransactionFees', sort: true, width: '94px', align: 'right'},
        {title: 'Other', icon: '', value: 'other', sort: true, width: '94px', align: 'right'},
        {title: 'Total', icon: '', value: 'totalProductAmount', sort: true, width: '94px', align: 'right'},
      ],
      titleObj: [
        {title: 'Date/Time', icon: '', value: 'orderDate', sort: false, width: '140px', align: 'start'},
        {title: 'Type', icon: '', value: 'status', sort: true, width: '84px', align: 'start'},
        {title: 'Order ID', icon: '', value: 'orderId', sort: true, width: '84px', align: 'start'},
        {title: 'Sku', icon: '', value: 'sku', sort: true, width: '84px', align: 'start'},
        {title: 'Description', icon: '', value: 'description', sort: true, width: '240px', align: 'start'},
        {title: 'Marketplace', icon: '', value: 'marketplace', sort: true, width: '180px', align: 'start'},
        {title: 'Account Type', icon: '', value: 'accountType', sort: true, width: '120px', align: 'start'},
        {title: 'FulFillment', icon: '', value: 'fulFillment', sort: true, width: '84px', align: 'start'},
        {title: 'Order City', icon: '', value: 'city', sort: true, width: '133px', align: 'start'},
        {title: 'Order State', icon: '', value: 'state', sort: true, width: '125px', align: 'start'},
        {title: 'Order Postal', icon: '', value: 'postcode', sort: true, width: '125px', align: 'start'},
        {title: 'Payment Method', icon: '', value: 'paymentMethod', sort: true, width: '133px', align: 'start'},
        {title: 'Tax Collection Model', icon: '', value: 'taxCollectionModel', sort: true, width: '138px', align: 'start'},
        {title: 'Quantity', icon: '', value: 'quantity', sort: true, width: '70px', align: 'right'},
        {title: 'Product Sales', icon: '', value: 'productSale', sort: true, width: '94px', align: 'right'},
        {title: 'Product Sales Tax', icon: '', value: 'productSaleTax', sort: true, width: '94px', align: 'right'},
        {title: 'Shipping Credits', icon: '', value: 'shippingAmount', sort: true, width: '94px', align: 'right'},
        {title: 'Shipping Credits Tax', icon: '', value: 'shippingAmountTax', sort: true, width: '94px', align: 'right'},
        {title: 'Gift Wrap Credits', icon: '', value: 'giftWrapCredits', sort: true, width: '94px', align: 'right'},
        {title: 'Gift Wrap Credits Tax', icon: '', value: 'giftWrapCreditsTax', sort: true, width: '94px', align: 'right'},
        {title: 'Promotional Rebates', icon: '', value: 'promotionalRebates', sort: true, width: '94px', align: 'right'},
        {title: 'Promotional Rebates Tax', icon: '', value: 'promotionalRebatesTax', sort: true, width: '94px', align: 'right'},
        {title: 'Marketplace Withheld Tax', icon: '', value: 'marketplaceWithheldTax', sort: true, width: '94px', align: 'right'},
        {title: 'Selling Fees', icon: '', value: 'sellingFees', sort: true, width: '94px', align: 'right'},
        {title: 'FBA Fees', icon: '', value: 'fBAFees', sort: true, width: '94px', align: 'right'},
        {title: 'Other Transaction Fees', icon: '', value: 'otherTransactionFees', sort: true, width: '94px', align: 'right'},
        {title: 'Other', icon: '', value: 'other', sort: true, width: '94px', align: 'right'},
        {title: 'Total', icon: '', value: 'totalProductAmount', sort: true, width: '94px', align: 'right'},
      ],
      pagination: {
        sortBy: 'orderDate',
        descending: true
      },
      filterObject: {
        startDate: '',
        endDate: '',
        minDate: '',
        maxDate: '',
      },
      cardHight: 0,
      mainHeight: 0,
      defaultStartDate: '',
      defaultEndDate: '',
      showCustomDatepicker: false,
      firstLoading: false,
    }
  },
  created() {
  },
  beforeMount () {
  },
  mounted () {
    this.cardHight = window.innerHeight - 255
    this.mainHeight = window.innerHeight - 145
    console.log('this.cardHight', this.cardHight, this.mainHeight)
    this.defaultEndDate = new Date()
    let currentDate = new Date()
    this.defaultStartDate = new Date(currentDate.setDate(currentDate.getDate() - 29))
    this.filterObject.startDate = this.defaultStartDate
    this.filterObject.endDate = this.defaultEndDate
  },
  watch: {
    filterObject: {
      handler () {
        console.log('filterObject', this.filterObject)
      },
      deep: true
    },
  },
  methods: {
    closeFilter (data) {
      console.log('data', data)
      this.filterObject.startDate = data.startDate
      this.filterObject.endDate = data.endDate
      this.getListing()
    },
    dragArray (value) {
      let el1 = document.getElementById('DivValue')
      el1.innerHTML = ''
      let output = "<div id=\"outerbox\">"
      let TempKey = '' 
      if (value === 'reset') {
        let tempArr = JSON.parse(JSON.stringify(this.resetColumnList))
        this.titleObj = tempArr
        for (let II = 0; II < this.listingArray.length; II++) {
          output += '<div class="min-w-min flex border-r border-l border-b p-2 border-gray1 bg-white text-sm items-center py-1 cursor-pointer hover:bg-gray-50"><div style="text-align:center;width:54px!important;padding-right: 8px !important;white-space: pre-wrap;" class="xsmall_col"><span class="heading-6-1 text-text1"> '+ (II + 1) + '</span></div>'
          for (let JJ = 0; JJ < this.resetColumnList.length; JJ++) {
            TempKey = this.resetColumnList[JJ].value
            let renderValue = ''
            let CSSVal = ''
            if (TempKey === 'productSale' || TempKey === 'productSaleTax' || TempKey === 'shippingAmountTax' || TempKey === 'totalProductAmount') {
              renderValue = this.amountFormaterWithToFix(this.listingArray[II][TempKey])
              CSSVal = 'text-aligh:right !important;float: right !important;'
            } else if (TempKey === 'description') {
              renderValue = this.listingArray[II][TempKey]
              CSSVal = 'word-break: break-all !important;white-space: initial !important;white-space: nowrap !important;overflow: hidden !important;text-overflow: ellipsis !important;display: block;width:' +  this.resetColumnList[JJ].width + '!important;'
            } else if (TempKey === 'quantity' || TempKey === 'giftWrapCredits' || TempKey === 'giftWrapCreditsTax' || TempKey === 'promotionalRebates' || TempKey === 'promotionalRebatesTax' || TempKey === 'marketplaceWithheldTax' || TempKey === 'sellingFees' || TempKey === 'fBAFees' || TempKey === 'otherTransactionFees' || TempKey === 'other'  || TempKey === 'shippingAmount') {
              renderValue = this.listingArray[II][TempKey]
              CSSVal = 'text-aligh:right !important;float: right !important;'
            } else if (TempKey === 'orderDate') {
              renderValue = this.dateTimeFilter(this.listingArray[II][TempKey])
            } else {
              renderValue = this.listingArray[II][TempKey]
            }
            output +='<div class="" style="width:' +  this.resetColumnList[JJ].width + '!important;padding-right: 8px !important;white-space: pre-wrap;"><span style="' + CSSVal + '" class="heading-6-1 text-text1"> '+ renderValue + '</span></div><br>'
          }
          output += '</div>'
        }
        localStorage.removeItem('orderTitleObj')
      } else {
        for (let II = 0; II < this.listingArray.length; II++) {
          output += '<div class="min-w-min flex border-r border-l border-b p-2 border-gray1 bg-white text-sm items-center py-1 cursor-pointer hover:bg-gray-50"><div style="text-align:center;width:54px!important;padding-right: 8px !important;white-space: pre-wrap;" class="xsmall_col"><span class="heading-6-1 text-text1"> '+ (II + 1) + '</span></div>'
          for (let JJ = 0; JJ < this.titleObj.length; JJ++) {
            TempKey = this.titleObj[JJ].value
            let renderValue = ''
            let CSSVal = ''
            if (TempKey === 'productSale' || TempKey === 'productSaleTax' || TempKey === 'shippingAmountTax' || TempKey === 'totalProductAmount') {
              renderValue = this.amountFormaterWithToFix(this.listingArray[II][TempKey])
              CSSVal = 'text-aligh:right !important;float: right !important;'
            } else if (TempKey === 'description') {
              renderValue = this.listingArray[II][TempKey]
              CSSVal = 'word-break: break-all !important;white-space: initial !important;white-space: nowrap !important;overflow: hidden !important;text-overflow: ellipsis !important;display: block;width:' +  this.titleObj[JJ].width + '!important;'
            } else if (TempKey === 'quantity' || TempKey === 'giftWrapCredits' || TempKey === 'giftWrapCreditsTax' || TempKey === 'promotionalRebates' || TempKey === 'promotionalRebatesTax' || TempKey === 'marketplaceWithheldTax' || TempKey === 'sellingFees' || TempKey === 'fBAFees' || TempKey === 'otherTransactionFees' || TempKey === 'other'  || TempKey === 'shippingAmount') {
              renderValue = this.listingArray[II][TempKey]
              CSSVal = 'text-aligh:right !important;float: right !important;'
            } else if (TempKey === 'orderDate') {
              renderValue = this.dateTimeFilter(this.listingArray[II][TempKey])
            } else {
              renderValue = this.listingArray[II][TempKey]
            }
            output +='<div class="" style="width:' +  this.titleObj[JJ].width + '!important;padding-right: 8px !important;white-space: pre-wrap;"><span style="' + CSSVal + '" class="heading-6-1 text-text1"> '+ renderValue + '</span></div><br>'
          }
          output += '</div>'
        }
      }
      output += '</div>'
      el1.innerHTML = output;
      this.drag = false
    },
   openCloseFilter () {
      if (this.isFilterOpen) {
        this.isFilterOpen = false
      } else {
        this.isFilterOpen = true
      }
      console.log('openCloseFilter')
    },
    customDateListener (data) {
      console.log('datadatadatadatadatadata', data)
      this.showCustomDatepicker = false
      if (data !== null) {
        this.filterObject.startDate = data.startDate
        this.filterObject.endDate = data.endDate
      }
    },
    saveToLocal () {
      localStorage.setItem('orderTitleObj', JSON.stringify(this.titleObj))
    },
    resetColumn () {
      this.dragArray('reset')
    },
    applyFilter() {
      this.getListing()
    },
    getListing () {
      this.firstLoading = false
      console.log('this.filterObject.startDate 123 123', this.filterObject.startDate)
      console.log('this.filterObject.endDate 123 123', this.filterObject.endDate)
      let utcSTART = moment(this.filterObject.startDate).format("YYYY-MM-DD");
      let utcEND = moment(this.filterObject.endDate).format("YYYY-MM-DD");
      this.$store.dispatch('SetLoader', {status: true, message: 'Please wait, it takes some time ...'})
      API.GetAccPeriTechnologyListing(
        utcSTART,
        utcEND,
        false,
        response => {
          this.listingArray = response.Data === null ? [] : response.Data
          this.firstLoading = true
          this.listingArray.forEach(element => {
            element.marketplace = 'PerimeterTechnologies.com'
            element.accountType = 'Standard Orders'
            element.fulFillment = 'Seller'
            element.giftWrapCredits = '0'
            element.giftWrapCreditsTax = '$0.00'
            element.promotionalRebates = '0'
            element.promotionalRebatesTax = '$0.00'
            element.marketplaceWithheldTax = '$0.00'
            element.sellingFees = '$0.00'
            element.fBAFees = '$0.00'
            element.otherTransactionFees = '$0.00'
            element.other = '$0.00'
            element.taxCollectionModel = 'Avatax'
          });
          setTimeout(() => {
            let filterDataStoredInLocalStorage = localStorage.getItem('orderTitleObj')
            if (filterDataStoredInLocalStorage !== null) {
              let data = JSON.parse(filterDataStoredInLocalStorage)
              this.titleObj = data
              this.dragArray('false')
              this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
            } else {
              this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
              let el2 = document.getElementById('DivValue')
              let outputA = "<div id=\"outerboxA\">"
              for (let indexA = 0; indexA < this.listingArray.length; indexA++) {
                outputA +='<div class="min-w-min flex border-r border-l border-b p-2 border-gray1 bg-white text-sm items-center py-1 cursor-pointer hover:bg-gray-50"><div style="text-align:center;width:54px!important;padding-right: 8px !important;white-space: pre-wrap;" class="xsmall_col"><span class="heading-6-1 text-text1"> '+ (indexA + 1) + '</span></div><div style="width:140px!important;padding-right: 8px !important;white-space: pre-wrap;" class="dates_col"><span class="heading-6-1 text-text1">'+ this.dateTimeFilter() +'</span></div><div style="width:84px!important;padding-right: 8px !important;white-space: pre-wrap;" class="small_col"><span class="heading-6 text-text1">'+ this.listingArray[indexA].status +'</span></div><div style="width:84px!important;padding-right: 8px !important;white-space: pre-wrap;" class="small_col"><span class="heading-6 text-text1">'+ this.listingArray[indexA].orderId +'</span></div><div style="width:84px!important;padding-right: 8px !important;white-space: pre-wrap;" class="small_col"><span class="heading-6 text-text1">'+ this.listingArray[indexA].sku +'</span></div><div style="width:240px!important;padding-right: 8px !important;white-space: pre-wrap;" class="desc_col"><span class="heading-6 text-text1 overFlowParaA" style="word-break: break-all !important;white-space: initial !important;white-space: nowrap !important;overflow: hidden !important;text-overflow: ellipsis !important;display: block;">'+ this.listingArray[indexA].description +'</span></div><div style="width:180px!important;padding-right: 8px !important;white-space: pre-wrap;" class="mid_col"><span class="heading-6 text-text1">'+ this.listingArray[indexA].marketplace +'</span></div><div style="width:120px!important;padding-right: 8px !important;white-space: pre-wrap;" class="dates_col "><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].accountType +'</span></div><div style="width:84px!important;padding-right: 8px !important;white-space: pre-wrap;" class="small_col "><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].fulFillment +'</span></div><div style="width:133px!important;padding-right: 8px !important;white-space: pre-wrap;" class="avgSell_col "><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].city +'</span></div><div style="width:125px!important;padding-right: 8px !important;white-space: pre-wrap;" class="avgSell_col "><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].state +'</span></div><div style="width:125px!important;padding-right: 8px !important;white-space: pre-wrap;" class="avgSell_col "><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].postcode +'</span></div><div style="width:133px!important;padding-right: 8px !important;white-space: pre-wrap;" class="avgSell_col "><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].paymentMethod +'</span></div><div style="width:138px!important;padding-right: 8px !important;white-space: pre-wrap;" class="avgSell2_col "><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].taxCollectionModel +'</span></div><div style="width:70px!important;padding-right: 8px !important;white-space: pre-wrap;" class="avgSell_col rightText text-right"><span class="heading-6-1 text-text1 ">'+ this.listingArray[indexA].quantity +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.amountFormaterWithToFix(this.listingArray[indexA].productSale) +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.amountFormaterWithToFix(this.listingArray[indexA].productSaleTax) +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].shippingAmount +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.amountFormaterWithToFix(this.listingArray[indexA].shippingAmountTax) +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].giftWrapCredits +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].giftWrapCreditsTax +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].promotionalRebates +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].promotionalRebatesTax +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].marketplaceWithheldTax +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].sellingFees +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].fBAFees +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].otherTransactionFees +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.listingArray[indexA].other +'</span></div><div style="width:94px!important;padding-right: 8px !important;white-space: pre-wrap;" class="vsmall_col rightText text-right"><span class="heading-6-1 text-text1">'+ this.amountFormaterWithToFix(this.listingArray[indexA].totalProductAmount) +'</span></div></div>'
              }
              outputA += '</div>'
              el2.innerHTML = outputA
            }
          }, 3000)
          console.log(response.Data)
        },
        error => {
          this.resetPaginationValues = false
          this.$store.dispatch('SetLoader', {status: false, message: 'Loading ...'})
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },
    openDrag () {
      this.deleteConfirm = true
      console.log('click')
    },
    sortByColumn (type, i, val1, val2) {
      console.log('type', type)
      console.log('i', i)
      console.log('val1', val1)
      console.log('val2', val2)
      this.titleObj[i].sort = !val1
      this.pagination.descending = val1
      this.pagination.sortBy = val2
      console.log('this.pagination.descending', this.pagination.descending)
      if (this.pagination.descending) {
        console.log('click 1')
        this.listingArray.sort(function (a, b) {
          console.log('a', a)
          console.log('b', b)
          if (type === 'orderDate') {
            var nameA = a.orderDate
            var nameB = b.orderDate
          } else if (type === 'status') {
            nameA = a.status
            nameB = b.status
          } else if (type === 'orderId') {
            nameA = a.orderId
            nameB = b.orderId
          } else if (type === 'sku') {
            nameA = a.sku
            nameB = b.sku
          } else if (type === 'description') {
            nameA = a.description
            nameB = b.description
          } else if (type === 'city') {
            nameA = a.city
            nameB = b.city
          } else if (type === 'state') {
            nameA = a.state
            nameB = b.state
          } else if (type === 'postcode') {
            nameA = a.postcode
            nameB = b.postcode
          } else if (type === 'paymentMethod') {
            nameA = a.paymentMethod
            nameB = b.paymentMethod
          } else if (type === 'quantity') {
            nameA = a.quantity
            nameB = b.quantity
          } else if (type === 'productSale') {
            nameA = a.productSale
            nameB = b.productSale
          } else if (type === 'productSaleTax') {
            nameA = a.productSaleTax
            nameB = b.productSaleTax
          } else if (type === 'shippingAmount') {
            nameA = a.shippingAmount
            nameB = b.shippingAmount
          } else if (type === 'shippingAmountTax') {
            nameA = a.shippingAmountTax
            nameB = b.shippingAmountTax
          } else if (type === 'totalProductAmount') {
            nameA = a.totalProductAmount
            nameB = b.totalProductAmount
          }
          console.log('nameA-------------------- 1', nameA)
          console.log('nameB-------------------- 1', nameB)
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        })
      } else {
        console.log('click 2')
        this.listingArray.reverse(function (a, b) {
          if (type === 'orderDate') {
            var nameA = a.orderDate
            var nameB = b.orderDate
          } else if (type === 'status') {
            nameA = a.status
            nameB = b.status
          } else if (type === 'orderId') {
            nameA = a.orderId
            nameB = b.orderId
          } else if (type === 'sku') {
            nameA = a.sku
            nameB = b.sku
          } else if (type === 'description') {
            nameA = a.description
            nameB = b.description
          } else if (type === 'city') {
            nameA = a.city
            nameB = b.city
          } else if (type === 'state') {
            nameA = a.state
            nameB = b.state
          } else if (type === 'postcode') {
            nameA = a.postcode
            nameB = b.postcode
          } else if (type === 'paymentMethod') {
            nameA = a.paymentMethod
            nameB = b.paymentMethod
          } else if (type === 'quantity') {
            nameA = a.quantity
            nameB = b.quantity
          } else if (type === 'productSale') {
            nameA = a.productSale
            nameB = b.productSale
          } else if (type === 'productSaleTax') {
            nameA = a.productSaleTax
            nameB = b.productSaleTax
          } else if (type === 'shippingAmount') {
            nameA = a.shippingAmount
            nameB = b.shippingAmount
          } else if (type === 'shippingAmountTax') {
            nameA = a.shippingAmountTax
            nameB = b.shippingAmountTax
          } else if (type === 'totalProductAmount') {
            nameA = a.totalProductAmount
            nameB = b.totalProductAmount
          }
          console.log('nameA-------------------- 2', nameA)
          console.log('nameB-------------------- 2', nameB)
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        })
      }
      this.dragArray()
      this.titleObj[i].isDesc = !this.titleObj[i].isDesc
    },
    async exportReport () {
      if (this.firstLoading && this.listingArray.length > 0) {
        let utcSTART = moment(this.filterObject.startDate).format("YYYY-MM-DD");
        let utcEND = moment(this.filterObject.endDate).format("YYYY-MM-DD");
        let day1 = moment(this.filterObject.startDate).format("DD-MM-YY")
        let day2 = moment(this.filterObject.endDate).format("DD-MM-YY")
        let Time = 'Order Refund periMTechnology' + day1 + '-To-' + day2
        let data = new FormData()
        data.append('from', utcSTART)
        data.append('to', utcEND)
        data.append('export', true)
        await this.downloadAttachment('api/v1/analytics/perimeterTech/ordersAndRefunds', `${Time}` + '.xlsx', data)
      }
    },
    async downloadAttachment (subUrl, fileName, formData) {
      let url = this.$store.getters.liveServerUrl + subUrl
      // If Want To cancel request
      const cancelToken = axios.CancelToken
      const source = cancelToken.source()
      let originalFileName = fileName
      this.$store.dispatch('CancelDownloadRequest', source)
      // Show loader while downloading
      this.$store.dispatch('SetDownloadLoader', true)
      // Calling Api and waiting for response
      let response = await downloadFile(formData, url, source)
      // Checking for status if 200 == success
      if (response.status === 200) {
        this.$store.dispatch('CancelDownloadRequest', null)
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response.data]))
        console.log(window.URL.createObjectURL(new Blob([response.data])))
        link.setAttribute('download', originalFileName)
        document.body.appendChild(link)
        link.click()
        // CLosing loader and reseting text in loader
        this.$store.dispatch('SetDownloadLoader', false)
        this.$store.dispatch('SetDownloadMessage', '')
      } else {
        this.$store.dispatch('CancelDownloadRequest', null)
        this.$store.dispatch('SetDownloadMessage', '')
        this.$store.dispatch('SetDownloadLoader', false)
      }
    },
    amountFormaterWithToFix (amount) {
      let value = parseFloat(amount).toFixed(2)
      // return '$' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return `$${value.toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    },
    dateTimeFilter (dateTime) {
      if (dateTime === '') {
        return ''
      }
      return moment(dateTime).format('DD-MM-YYYY HH:mm A')
    },
  },
  destroyed() {
    localStorage.removeItem('orderTitleObj')
  },
  beforeDestroy () {
    localStorage.removeItem('orderTitleObj')
  }
}
</script>
<style scoped>

.xsmall_col {
  /* min-width: 54px !important; */
  /* width: 54px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.dates_col {
  /* min-width: 120px !important; */
  /* width: 120px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}

.rightText {
  text-align: right !important;
  justify-content: right !important;
}
.total_col {
  /* min-width: 82px !important; */
  /* width: 82px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.vsmall_col {
  /* min-width: 94px !important; */
  /* width: 94px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.avgSell_col {
  /* min-width: 133px !important; */
  /* width: 133px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.avgSell2_col {
  /* min-width: 138px !important; */
  /* width: 138px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}

.mid_col {
  /* min-width: 180px !important; */
  /* width: 180px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.small_col {
  /* min-width: 84px !important; */
  /* width: 84px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
.overFlowParaA {
  word-break: break-all !important;
  white-space: initial !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: block;
}

.large_col {
  /* min-width: 260px !important; */
  /* width: 260px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}

.desc_col {
  /* min-width: 240px !important; */
  /* width: 240px !important; */
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}

</style>
